import { useStore } from 'effector-react'

import {
  $giftsCategories,
  $totalCountOfGiftsCategories,
  getGiftsCategories,
  giftCategoriesListMounted,
} from './model'
import { GiftCategoryRequest } from './types'

export const useGiftCategories = () => {
  const onChangeGiftCategoriesList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: GiftCategoryRequest) => {
    giftCategoriesListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }
  const loading = useStore(getGiftsCategories.pending)

  const giftsCategories = useStore($giftsCategories)
  const totalCountOfGifts = useStore($totalCountOfGiftsCategories)
  return {
    giftsCategories,
    totalCountOfGifts,
    loading,
    onChangeGiftCategoriesList,
  }
}
